// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"An-z","badgeLink":"Bn-z","category":"Cn-z"};